import { Dialog } from '@mui/material'
import Lottie from 'lottie-react';
import React from 'react'
import OrderPlacedAnimation from './Lotties/orderPlacedAnime.json';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
    dialogPaper: {
      borderRadius: '12px !important',
      width: '100vmax',
      height: '100vh',
      transform: 'scale(1)',
      transition: 'transform 0.5s ease-in-out',
      boxShadow: 'none !important',
      backgroundColor: 'transparent !important',
      padding: '0 !important',
      display: 'flex',
      justifyContent: 'center'
      
    },
    
   
    '@media (max-width: 600px)': {
      dialogPaper: {
        // CSS styles specific to max-width 600px
        // For example:
        width: '100vw',
        height: '100vh',
        padding: 0,
        margin: 0,
        margin: '0 !important', // Override margin
        maxHeight: '100% !important', // Override max-height
        borderRadius: '12px !important',
        backgroundColor: 'transparent !important',
        display: 'flex',
        justifyContent: 'center'
      },
    },
  });

function OrderPlacedAnime(showOrderConfirmationAnimation) {
    const classes = useStyles();
    // const defaultOptions = {
    //     loop: true,
    //     autoplay: true,
    //     animationData: OrderPlacedAnimation,
    //     rendererSettings: {
    //       preserveAspectRatio: "xMidYMid slice"
    //     }
    //   };
    
    return (
      <Dialog
        onClose={'close'}
        open={showOrderConfirmationAnimation}
        classes={{
            paper: classes.dialogPaper,
          }}
          BackdropProps={{
            style: {
              backgroundColor: "rgba(8, 8, 8, 0.541)",
              backdropFilter: "blur(8px)",
            },
          }}
      >
        <Lottie 
          animationData={OrderPlacedAnimation}
          height={400}
          width={400}
        />
      </Dialog>
    );
  }

export default OrderPlacedAnime;